import {
  EDIT_WORKSPACE_TYPE,
  METRIC_KEY,
  VISUALIZE_TYPE
} from '../../utilities/constants/Constants';
import {
  convertFromImperialToMetric,
  getActiveCanvas,
  getAreaUnit,
  insertAt
} from '../../utilities/HelperFunctions/HelperFunctions';
import { renderProject } from '../../utilities/ProjectCanvasRenderer/ProjectCanvasRenderer';
import actionTypes from '../actionTypes';
import {
  addToUndoManager,
  checkForElementsControls,
  clearCanvas,
  getElementImagePath,
  loadCanvasFromProject,
  mouseDownOnObject,
  selectObject,
  setViewMode
} from '../fabricCanvasActions';
import { pricePerUnitAreaOfMaterial } from '../finalCheckActions';
import { checkIfStickersTypeApp, getUnit } from '../homeActions';
import { isPlacingMappedPlacing } from '../ProjectData/Placing';
import { getPlacings } from '../ProjectData/Project';

export const createNewStickerAction = () => (dispatch, getState) => {
  const { stickerIdList, stickerCounter, activeStickerId } = getState().sticker;
  const oldStickerId = activeStickerId;
  const counter = stickerCounter + 1;
  const uniqueId = `sticker_${counter}`;
  dispatch({
    type: actionTypes.SET_STICKER_COUNTER,
    payload: { counter }
  });
  const newList = [...stickerIdList];
  newList.push(uniqueId);
  dispatch({
    type: actionTypes.SET_ACTIVE_STICKER_ID,
    payload: { id: uniqueId }
  });
  dispatch({
    type: actionTypes.SET_STICKER_ID_LIST,
    payload: { list: newList }
  });
  dispatch(clearCanvas());
  dispatch(selectObject(null));
  dispatch(generatePreviewOfStickers());
  dispatch(
    addToUndoManager({
      undo: () => {
        dispatch(undoOrRedoCreateNewSticker(oldStickerId));
      },
      redo: () => {
        dispatch(undoOrRedoCreateNewSticker(uniqueId));
      }
    })
  );
};

export const undoOrRedoCreateNewSticker = inId => dispatch => {
  dispatch(stickerIsSelected(inId));
  dispatch(updateStickerIdList(inId));
};

export const updateStickerIdList = inId => (dispatch, getState) => {
  if (dispatch(checkIfStickersTypeApp()) && inId) {
    const { stickerIdList } = getState().sticker;
    const newList = [...stickerIdList];
    if (!newList.find(id => id == inId)) {
      const numberList = newList.map(id => {
        const matchedIds = id.split('sticker_');
        if (matchedIds.length > 1) {
          return matchedIds[1];
        }
        return '';
      });
      const matched = inId.split('sticker_');
      if (matched.length > 1) {
        const inIdNumber = matched[1];

        insertAt(numberList, inIdNumber);
        const updatedIdList = numberList.map(id => `sticker_${id}`);
        dispatch({
          type: actionTypes.SET_ACTIVE_STICKER_ID,
          payload: { id: inId }
        });
        dispatch({
          type: actionTypes.SET_STICKER_ID_LIST,
          payload: { list: updatedIdList }
        });
      }
    }
  }
};

export const placingsOfSticker = stickerId => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  const allPlacings = getPlacings(project);
  return allPlacings.filter(
    placing => stickerId && placing.groupId == stickerId && !placing.destroy
  );
};

export const stickerPlacingImageId = placing => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  const allPlacings = getPlacings(project);
  if (placing) {
    return `sticker_${placing.groupId}_placing_${allPlacings.indexOf(placing)}`;
  }
  return null;
};

export const imageDataListOfActiveSticker = () => (dispatch, getState) => {
  const { activeStickerId } = getState().sticker;
  const activeStickerPlacings = dispatch(placingsOfSticker(activeStickerId));
  return activeStickerPlacings.map(placing => {
    const dict = {};
    if (placing.placeable) {
      dict.preview = dispatch(getElementImagePath(placing));
    }
    dict.imageId = dispatch(stickerPlacingImageId(placing));
    dict.placing = placing;
    return dict;
  });
};

export const stickerPlacingIsSelected = inId => dispatch => {
  const list = dispatch(imageDataListOfActiveSticker());
  const matchedItems = list.filter(item => item.imageId == inId);
  let selectedPlacing = null;
  if (matchedItems.length > 0) {
    selectedPlacing = matchedItems[0].placing;
  }
  const canvas = dispatch(getActiveCanvas(selectedPlacing));
  const matchedObjects = canvas
    .getObjects()
    .filter(object => object.placing == selectedPlacing);
  const matchedObject = matchedObjects.length > 0 ? matchedObjects[0] : null;
  dispatch(selectObject(matchedObject));
};

export const stickerIsSelected = inId => dispatch => {
  dispatch({
    type: actionTypes.SET_ACTIVE_STICKER_ID,
    payload: { id: inId }
  });
  dispatch(clearCanvas());
  dispatch(loadCanvasFromProject());
};

export const enebaleOrDisableStickerDrag = canDrag => dispatch => {
  dispatch({
    type: actionTypes.SET_ENABLE_OR_DIABLE_STICKER_DRAG,
    payload: { canDrag }
  });
  dispatch(checkForElementsControls());
};

export const generatePreviewOfStickers = () => (dispatch, getState) => {
  if (dispatch(checkIfStickersTypeApp())) {
    const { stickerIdList } = getState().sticker;
    const renderJSONList = [];
    stickerIdList.forEach(stickerId => {
      const stickerPlacings = dispatch(placingsOfSticker(stickerId));
      if (stickerPlacings.length > 0) {
        const stickerFrame = getStickerFrame(stickerPlacings);
        let counter = 0;
        const layers = [];

        stickerPlacings.forEach(stickerPlacing => {
          const data = {};
          data.x = stickerPlacing.xOffset - stickerFrame.x;
          data.y = stickerPlacing.yOffset - stickerFrame.y;
          data.width = stickerPlacing.width;
          data.height = stickerPlacing.height;
          data.image = dispatch(getElementImagePath(stickerPlacing));
          data.angle = stickerPlacing.angle;
          data.flip = stickerPlacing.flipX;
          data.tiled = stickerPlacing.tiled;
          data.opacity = stickerPlacing.opacity ? stickerPlacing.opacity : 1;
          layers[counter++] = data;
        });
        const renderData = {
          width: stickerFrame.width,
          height: stickerFrame.height,
          layers
        };
        renderJSONList.push(renderData);
      }
    });
    renderProject(renderJSONList, dataURLs => {
      const imageDataList = dataURLs.map((dataURL, index) => {
        const dict = {};
        dict.preview = dataURL.image_data;
        dict.imageId = `${stickerIdList[index]}`;
        dict.placing = null;
        return dict;
      });
      dispatch({
        type: actionTypes.SET_STICKER_PREVIEW_LIST,
        payload: { list: imageDataList }
      });
    });
  }
};

export const getStickerFrame = placings => {
  let stickerMinX = 999999;
  let stickerMinY = 999999;
  let stickerMaxX = 0;
  let stickerMaxY = 0;

  placings.forEach(placing => {
    const placingWidth = placing.width;
    const placingHeight = placing.height;
    const placingXOffset = placing.xOffset;
    const placingYOffset = placing.yOffset;
    if (placing.angle != 0) {
      const centerPointX = placingXOffset + placingWidth / 2;
      const centerPointY = placingYOffset + placingHeight / 2;
      const deg2radians = (Math.PI * 2) / 360;
      const rad = placing.angle * deg2radians;
      const costheta = Math.abs(Math.cos(rad));
      const sintheta = Math.abs(Math.sin(rad));

      const pointsList = [
        { x: placingXOffset - centerPointX, y: placingYOffset - centerPointY }
      ];
      pointsList.push({
        x: placingXOffset + placingWidth - centerPointX,
        y: placingYOffset - centerPointY
      });
      pointsList.push({
        x: placingXOffset + placingWidth - centerPointX,
        y: placingYOffset + placingHeight - centerPointY
      });
      pointsList.push({
        x: placingXOffset - centerPointX,
        y: placingYOffset + placingHeight - centerPointY
      });
      while (pointsList.length) {
        const point = pointsList.shift();
        const newXOffset =
          point.x * costheta - point.y * sintheta + centerPointX;
        const newYOffset =
          point.x * sintheta + point.y * costheta + centerPointY;

        stickerMinX = stickerMinX > newXOffset ? newXOffset : stickerMinX;
        stickerMinY = stickerMinY > newYOffset ? newYOffset : stickerMinY;
        stickerMaxX = stickerMaxX < newXOffset ? newXOffset : stickerMaxX;
        stickerMaxY = stickerMaxY < newYOffset ? newYOffset : stickerMaxY;
      }
    } else {
      stickerMinX = stickerMinX > placingXOffset ? placingXOffset : stickerMinX;
      stickerMinY = stickerMinY > placingYOffset ? placingYOffset : stickerMinY;
      stickerMaxX =
        stickerMaxX < placingXOffset + placingWidth
          ? placingXOffset + placingWidth
          : stickerMaxX;
      stickerMaxY =
        stickerMaxY < placingYOffset + placingHeight
          ? placingYOffset + placingHeight
          : stickerMaxY;
    }
  });

  placings.forEach(placing => {
    placing.groupWidth = stickerMaxX - stickerMinX;
    placing.groupHeight = stickerMaxY - stickerMinY;
  });
  return {
    x: stickerMinX,
    y: stickerMinY,
    width: stickerMaxX - stickerMinX,
    height: stickerMaxY - stickerMinY
  };
};

export const createStickerPriceData = () => (dispatch, getState) => {
  const { stickerIdList, stickerPreviewList } = getState().sticker;
  const { unitSystem } = getState().home;
  const { project } = getState().finalCheck;
  const priceData = [];
  stickerIdList.forEach((inId, index) => {
    const placings = dispatch(placingsOfSticker(inId));
    let placing = null;
    if (placings.length > 0) {
      [placing] = placings;
    }
    if (placing) {
      let sWidth = placing.groupWidth;
      let sHeight = placing.groupHeight;
      let squareFootage = (sWidth / 12) * (sHeight / 12);
      const pricePerSticker =
        squareFootage *
        dispatch(pricePerUnitAreaOfMaterial(project.materialId));

      const matchedData = stickerPreviewList.find(
        previewData => previewData.imageId == inId
      );

      if (unitSystem == METRIC_KEY) {
        sWidth = convertFromImperialToMetric(sWidth);
        sHeight = convertFromImperialToMetric(sHeight);
        squareFootage = convertFromImperialToMetric(squareFootage);
      }
      priceData.push({
        id: inId,
        preview: matchedData ? matchedData.preview : null,
        name: `sticker ${index + 1}`,
        tooltip: `${sWidth.toFixed(2)} ${getUnit(
          unitSystem
        )} x ${sHeight.toFixed(2)} ${getUnit(
          unitSystem
        )} (${squareFootage.toFixed(2)} ${getAreaUnit(unitSystem)})`,
        quantity: placing.count,
        price: (pricePerSticker * placing.count).toFixed(2)
      });
    }
  });
  return priceData;
};

export const setStickerSpecificConfig = () => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  const allPlacings = getPlacings(project);
  const allStickerIds = allPlacings.map(placing => placing.groupId);
  const allStickerVisualizeIds = project.visualizePlacings.map(
    placing => placing.groupId
  );
  const stickerIdList = allStickerIds.filter(
    (inId, index) => allStickerIds.indexOf(inId) == index
  );
  const stickerVisualizeIdList = allStickerVisualizeIds.filter(
    (inId, index) => allStickerVisualizeIds.indexOf(inId) == index
  );
  dispatch({
    type: actionTypes.SET_STICKER_ID_LIST,
    payload: { list: stickerIdList }
  });
  dispatch(generatePreviewOfStickers());

  const counterList = stickerIdList.map(id => {
    const matched = id.split('sticker_');
    if (matched.length > 1) {
      return matched[1];
    }
    return -1;
  });
  let maxCounter = counterList.reduce((max, counter) => {
    if (counter > max) {
      max = counter;
    }
    return max;
  }, 0);
  maxCounter = parseInt(maxCounter, 10);

  const visualizeCounterList = stickerVisualizeIdList.map(id => {
    const matched = id.split('visualize_sticker_');
    if (matched.length > 1) {
      return matched[1];
    }
    return -1;
  });
  let visualizeMaxCounter = visualizeCounterList.reduce((max, counter) => {
    if (counter > max) {
      max = counter;
    }
    return max;
  }, 0);
  visualizeMaxCounter = parseInt(visualizeMaxCounter, 10);

  dispatch({
    type: actionTypes.SET_STICKER_COUNTER,
    payload: { counter: maxCounter }
  });
  dispatch({
    type: actionTypes.SET_VISUALIZE_STICKER_COUNTER,
    payload: { counter: visualizeMaxCounter }
  });
  const { wallCanvas } = getState().fabricCanvas;
  if (wallCanvas.getObjects().length > 0) {
    dispatch(mouseDownOnObject(wallCanvas.getObjects()[0]));
    dispatch(enebaleOrDisableStickerDrag(true));
  }
};

export const checkForMappedPlacings = inPlacing => (dispatch, getState) => {
  if (dispatch(checkIfStickersTypeApp())) {
    const { project } = getState().finalCheck;
    for (let i = project.visualizePlacings.length - 1; i >= 0; i--) {
      const vPlacing = project.visualizePlacings[i];
      if (isPlacingMappedPlacing(vPlacing, inPlacing)) {
        project.visualizePlacings.splice(i, 1);
        break;
      }
    }

    const { activeStickerId, stickerIdList } = getState().sticker;
    const activeStickerPlacings = dispatch(placingsOfSticker(activeStickerId));
    if (activeStickerPlacings.length <= 0) {
      let updatedIdList = [...stickerIdList];
      updatedIdList = updatedIdList.filter(id => id != activeStickerId);
      dispatch({
        type: actionTypes.SET_STICKER_ID_LIST,
        payload: { list: updatedIdList }
      });
      dispatch(createNewStickerAction());
    }
  }
};

export const setStickerDefaultViewMode = () => (dispatch, getState) => {
  const isViewOnlyPreviewMode = getState().modal.envData.view_only_preview_mode;
  if (isViewOnlyPreviewMode) {
    dispatch(setViewMode(VISUALIZE_TYPE));
  } else {
    dispatch(setViewMode(EDIT_WORKSPACE_TYPE));
  }
};
